const colors = {
    transparent: 'transparent',
    current: 'currentColor',
    black: '#000000',
    white: '#FFFFFF',

    // Cavenders color
    cav_purple: '#51372A',
    cav_red: '#AE132A',
    cav_dark_red: '#8f1015',
    cav_black: '#170f0d',
    cav_deep_light_gray: '#f2f2f0',
    cav_hover_brightred: '#aa0924',
    cav_clay: '#837554',
    cav_blue: '#2460CC',
    cav_light_gray: '#f2f2f2',
    cav_soft_gray: '#d4d4d4',
    cav_very_light_gray: '#cccccc',
    cav_light_black: '#111111',
    cav_gainsboro: '#e0e0e0',
    cav_night_rider: '#333333',
    cav_light_black_aqua: 'rgba(0, 0, 0, 0.5)',
    cav_mobile_nav_border_black: '#333',
    cav_carmine_red: '#bf2f38',
    cav_faq_head_gray: '#f2f2f0',
    cav_faq_anchor_red: '#8F1015',
    cav_btn_light_black: '#392b24',
    cav_header_bg: '#000000',
    cav_header_hover: 'rgba(80, 55, 42, 0.10)',
    cav_light_input_gray: '#636363',
    cav_calltoaction_darkred: '#AE122A',
    cav_pdp_dark_gray: '#636363',
    cav_pdp_light_gray: '#D9D9D9',
    cav_switch_gray: '#BABABA',
    cav_switch_ligh_pink: '#FBCECE',
    cav_charcoal: '#474747',
    cav_dark_charcoal: 'rgb(51, 51, 51)',
    cav_black_variant: 'rgb(57, 43, 36)',
    cav_dark_gray_rbg: '#534F4F',
    cav_chocolate_brown: '#392b24',
    cav_red_separator: '#AA0924',
    cav_dark_gray: 'rgba(99, 99, 99, 0.39)',
    cav_gray: 'rgba(0, 0, 0, 0.30)',
    cav_green: '#019328',
    cav_error_red: '#FF0000',
    cav_default_red: '#AE1F2B',
    cav_red_gift_card_error_red: '#FF0027',
    cav_gray_eye: '#B3B3B3',
    cav_dark_gray_info: '#efefef',
    cav_blue_outline: '#0D6EFD',
    cav_border_gray: '#B7B7B7',
    cav_border_light: '#E2E8F0',
    cav_light_gray_bg: '#EDEDED',

    whiteRed: {
        10: 'rgba(255, 0, 0, 0.10)',
        20: 'rgba(255, 0, 0, 0.20)'
    },
    cav_yello_green: '#8C8951',
    reddish_hue: 'rgba(174, 19, 42, 0.5)',
    cav_error_bg_red: 'rgba(255, 0, 0, 0.20)',
    cav_overlay_gray: 'rgb(255, 255, 255)',
    cav_brown: 'rgb(80, 54, 41)',
    cav_breadcrumb_gray: 'rgb(204, 204, 204)',

    whiteAlpha: {
        50: 'rgba(255, 255, 255, 0.04)',
        100: 'rgba(255, 255, 255, 0.06)',
        200: 'rgba(255, 255, 255, 0.08)',
        300: 'rgba(255, 255, 255, 0.16)',
        400: 'rgba(255, 255, 255, 0.24)',
        500: 'rgba(255, 255, 255, 0.36)',
        600: 'rgba(255, 255, 255, 0.48)',
        700: 'rgba(255, 255, 255, 0.64)',
        800: 'rgba(242, 242, 240, 1)',
        900: 'rgba(255, 255, 255, 0.92)'
    },

    blackAlpha: {
        50: 'rgba(0, 0, 0, 0.04)',
        100: 'rgba(0, 0, 0, 0.06)',
        200: 'rgba(0, 0, 0, 0.08)',
        300: 'rgba(0, 0, 0, 0.16)',
        400: 'rgba(0, 0, 0, 0.24)',
        500: 'rgba(0, 0, 0, 0.36)',
        550: 'rgba(0, 0, 0, 0.3)',
        600: 'rgba(0, 0, 0, 0.48)',
        630: 'rgba(0, 0, 0, 0.5)',
        650: 'rgba(0, 0, 0, 0.6)',
        700: 'rgba(0, 0, 0, 0.64)',
        800: 'rgba(0, 0, 0, 0.80)',
        900: 'rgba(0, 0, 0, 0.92)',
        950: 'rgb( 17, 17, 17)'
    },

    gray: {
        50: '#F3F3F3',
        75: '#F1F1F1',
        100: '#E5E5E5',
        150: '#E9E9E9',
        200: '#C9C9C9',
        300: '#AEAEAE',
        400: '#A0A0A0',
        500: '#939393',
        600: '#747474',
        700: '#5C5C5C',
        800: '#444444',
        900: '#181818'
    },

    red: {
        50: '#FEF1EE',
        100: '#FEDED8',
        200: '#FEB8AB',
        300: '#FE8F7D',
        400: '#FE7765',
        500: '#FE5C4C',
        600: '#EA001E',
        700: '#BA0517',
        800: '#8E030F',
        900: '#640103',
        950: 'rgb(174, 19, 42)',
        cvs: '#aa0924'
    },

    orange: {
        50: '#FEF1ED',
        100: '#FFDED5',
        200: '#FEB9A5',
        300: '#FF906E',
        400: '#FF784F',
        500: '#FF5D2D',
        600: '#D83A00',
        700: '#AA3001',
        800: '#7E2600',
        900: '#541D01'
    },

    yellow: {
        50: '#FBF3E0',
        100: '#F9E3B6',
        200: '#FCC003',
        300: '#E4A201',
        400: '#D79304',
        500: '#CA8501',
        600: '#A86403',
        700: '#8C4B02',
        800: '#6F3400',
        900: '#4F2100'
    },

    green: {
        50: '#EBF7E6',
        100: '#CDEFC4',
        200: '#91DB8B',
        300: '#45C65A',
        400: '#41B658',
        500: '#3BA755',
        600: '#2E844A',
        700: '#22683E',
        800: '#194E31',
        900: '#0E3522'
    },

    teal: {
        50: '#DEF9F3',
        100: '#ACF3E4',
        200: '#04E1CB',
        300: '#01C3B3',
        400: '#03B4A7',
        500: '#06A59A',
        600: '#0B827C',
        700: '#056764',
        800: '#024D4C',
        900: '#023434'
    },

    blue: {
        50: '#EEF4FF',
        100: '#D8E6FE',
        200: '#AACBFF',
        300: '#78B0FD',
        400: '#57A3FD',
        500: '#1B96FF',
        600: '#0176D3',
        700: '#0B5CAB',
        800: '#014486',
        900: '#032D60'
    },

    cyan: {
        50: '#EAF5FE%',
        100: '#CFE9FE',
        200: '#90D0FE',
        300: '#1AB9FF',
        400: '#08ABED',
        500: '#0D9DDA',
        600: '#107CAD',
        700: '#05628A',
        800: '#084968',
        900: '#023248'
    },

    purple: {
        50: '#F6F2FB',
        100: '#ECE1F9',
        200: '#D78FF5',
        300: '#C29EF1',
        400: '#B78DEF',
        500: '#AD7BEE',
        600: '#9050E9',
        700: '#7526E3',
        800: '#5A1BA9',
        900: '#401075'
    },

    pink: {
        50: '#F9F0FF',
        100: '#F2DEFE',
        200: '#E5B9FE',
        300: '#D892FE',
        400: '#D17DFE',
        500: '#CB65FF',
        600: '#BA01FF',
        700: '#9602C7',
        800: '#730394',
        900: '#520066'
    }
}

export default colors
